var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgILinkedinInfo = function SvgILinkedinInfo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4987 7.5C13.6038 7.5 14.6636 7.90522 15.445 8.62651C16.2264 9.34781 16.6654 10.3261 16.6654 11.3462V15.8333H13.8876V11.3462C13.8876 11.0061 13.7413 10.68 13.4808 10.4396C13.2203 10.1992 12.8671 10.0641 12.4987 10.0641C12.1303 10.0641 11.7771 10.1992 11.5166 10.4396C11.2561 10.68 11.1098 11.0061 11.1098 11.3462V15.8333H8.33203V11.3462C8.33203 10.3261 8.77102 9.34781 9.55242 8.62651C10.3338 7.90522 11.3936 7.5 12.4987 7.5V7.5Z",
    stroke: "#24252D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22266 7.5H3.72266V15.8333H6.22266V7.5Z",
    stroke: "#24252D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97266 5.83398C5.66301 5.83398 6.22266 5.27434 6.22266 4.58398C6.22266 3.89363 5.66301 3.33398 4.97266 3.33398C4.2823 3.33398 3.72266 3.89363 3.72266 4.58398C3.72266 5.27434 4.2823 5.83398 4.97266 5.83398Z",
    stroke: "#24252D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgILinkedinInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/i-linkedin-info.86e5739b04bd5d15a99158dedfd4de47.svg";